import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showToast, setShowToast] = useState(false);

  const handleNavClick = (path: string) => {
    if (path === '/saved' || path === '/profile') {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    } else {
      navigate(path);
    }
  };

  const tabs = [
    { id: 'home', path: '/', icon: 'ri-home-line', activeIcon: 'ri-home-fill', label: t('bottomNav.home') },
    { id: 'map', path: '/map', icon: 'ri-map-line', activeIcon: 'ri-map-fill', label: t('bottomNav.map') },
    { id: 'saved', path: '/saved', icon: 'ri-bookmark-line', activeIcon: 'ri-bookmark-fill', label: t('bottomNav.saved') },
    { id: 'profile', path: '/profile', icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: t('bottomNav.profile') }
  ];

  return (
    <>
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40">
        <div className="flex items-center justify-around h-16">
          {tabs.map(tab => {
            const isActive = location.pathname === tab.path;
            return (
              <button
                key={tab.id}
                onClick={() => handleNavClick(tab.path)}
                className="flex flex-col items-center justify-center flex-1 h-full transition-colors whitespace-nowrap"
              >
                <i 
                  className={`${isActive ? tab.activeIcon : tab.icon} text-xl mb-1 ${
                    isActive ? 'text-teal-600' : 'text-gray-500'
                  }`}
                ></i>
                <span className={`text-[10px] font-medium ${
                  isActive ? 'text-teal-600' : 'text-gray-500'
                }`}>
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>

      {/* Toast Notification */}
      {showToast && (
        <div className="md:hidden fixed bottom-20 left-1/2 -translate-x-1/2 bg-gray-900 text-white px-4 py-2 rounded-full text-sm z-50 animate-fade-in whitespace-nowrap">
          {t('bottomNav.comingSoon')}
        </div>
      )}
    </>
  );
}